import React, { useState } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import Icon from 'components/_UI/Icon';
import LoginModal from 'modules/onboarding/sign-in/LoginModal';
import { useAuth } from 'context/auth/Auth';
import paths from 'routes/paths';
import breakpoints from 'theme/breakpoints';
import colors from 'theme/colors';
import indexPriority from 'theme/z-index';
import { campaign } from './shared';

export default function LandingHeader() {
    const navigate = useNavigate();
    const { isAuth } = useAuth();
    const [isLoginOpen, setIsLoginOpen] = useState(false);

    return (
        <>
            <StyledHeader>
                <LogoLink href={paths.home}>
                    <Icon name="whizr-inline-logo-dark" />
                </LogoLink>

                <Badge>#3anosdewhizr</Badge>

                <HeaderCta
                    onClick={() => isAuth ? navigate(paths.dashboard.events) : setIsLoginOpen(true)}
                >
                    {isAuth ? 'Meu painel' : 'Entrar ou criar conta'}
                </HeaderCta>
            </StyledHeader>

            <LoginModal isOpen={isLoginOpen} onClose={() => setIsLoginOpen(false)} />
        </>
    );
}

const StyledHeader = styled.header`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 14px 20px;
    background: ${colors.neutralBackground};
    position: sticky;
    top: 0;
    z-index: ${indexPriority.header};
    box-shadow: 0 1px 4px rgba(0,0,0,0.06);

    @media screen and (min-width: ${breakpoints.smd}) {
        padding: 16px 32px;
    }
`;

const LogoLink = styled.a`
    width: 84px;
    height: 26px;
    cursor: pointer;
    flex-shrink: 0;
    --home-logo-color: ${campaign.purple};

    @media screen and (min-width: ${breakpoints.smd}) {
        width: 100px;
        height: 30px;
    }
`;

const Badge = styled.div`
    display: none;
    font-size: 13px;
    font-weight: 700;
    color: ${campaign.purple};

    @media screen and (min-width: ${breakpoints.smd}) {
        display: block;
    }
`;

const HeaderCta = styled.button`
    border: none;
    cursor: pointer;
    background: ${campaign.purple};
    color: #fff;
    font-size: 13.5px;
    font-weight: 700;
    padding: 10px 16px;
    border-radius: 50px;
    white-space: nowrap;
    transition: opacity 0.15s ease;

    &:hover {
        opacity: 0.9;
    }

    @media screen and (min-width: ${breakpoints.smd}) {
        font-size: 14.5px;
        padding: 11px 20px;
    }
`;
